<template>
  <span ref="numberGrow" :data_time="time" class="number-grow" :data-value="value">{{value}}</span>
</template>

<script>
export default {
  props: {
    time: {
      type: Number,
      default: 1
    },
    value: {
      type: String,
      default: '00'
    }
  },
  methods: {
    numberGrow (ele) {
      let _this = this
      let step = (Number(_this.value)*10) / (_this.time * 800) // 根据不同的值设定不同的跳动数字，以保证每个value最终跳动的次数一致
      let start = 0
      let t = setInterval(() => {
        start += step // 往初始值上加数字
        if (start > Number(_this.value)) {
          clearInterval(t)
          start = _this.value
          t = null
        }
        if (start < 10) {
          _this.$el.innerHTML = '0' + parseInt(start)
        } else {
          _this.$el.innerHTML = parseInt(start)
        }
        if (_this.value == 100) {
          // console.log('111')
          if (start < 10) {
            _this.$el.innerHTML = '00' + parseInt(start)
          } else if (start > 10 && start < 100) {
            _this.$el.innerHTML = '0' + parseInt(start)
          } else {
            _this.$el.innerHTML = parseInt(start)
          }
        } 
      }, 10);
    },
    handleClick () {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop // 滚动条滚动距离
      if (scrollTop > 200 && scrollTop < 300) {
        this.numberGrow(this.$refs.numberGrow)
      }
    },
    // 数字前自动补0
    formatZero (num, len) {
      if (String(num).length > len) {
        return num
      }
      return (Array(len).join(0) + num).slice(-len)
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleClick) // 监听滚动事件
  },
}
</script>